import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Session } from '../../services/session.service';
import { EulaAgreements } from '../../models/eulaagreements';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AnnouncementsComponent } from '../announcements/announcements.component';
import { lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-enduser-licenseagreement',
    template: `
    @for (i of eulaAgreements.slice(index, index + 1); track i) {
      <div>
        <div [innerHTML]="i.agreementText"></div>
        <div style="float: right;" class="app-mt2 app-mb2">
          <app-button
            mat-button
            emphasis="High"
            title="Accept User Agreement and License"
            alt="Accept User Agreement and License"
            (click)="licenseAgreed(true, i.agreementId, i.contNum, index)"
            label="I agree"
            >
          </app-button>
          &nbsp;
          <app-button
            mat-button
            title="Cancel and exit"
            alt="Cancel and exit"
            emphasis="Low"
            (click)="licenseCancelled(false)"
            label="Cancel"
            >
          </app-button>
        </div>
      </div>
    }
    `,
    styles: [``],
    standalone: false
})
export class EnduserLicenseagreementComponent implements OnInit {
  showTitle = true;
  eulaBinding: boolean = true;
  index: number = 0;
  @Input() hasEulaAgreement: boolean;
  @Input() eulaAgreements: any;
  @Input() translationRequest: TranslationRequest;
  @Output() acceptedEulaAgreement = new EventEmitter<boolean>();

  dialogRef: MatDialogRef<any>;

  constructor(
    private router: Router,
    public session: Session,
    public dialog: MatDialog,
    private http: HttpClient
  ) {}

  ngOnInit() {}

  public async licenseAgreed(input: any, id: any, contNum: any, index: any) {
    this.deleteMsg(id);
    if (index == this.eulaAgreements.length - 1) {
      this.dialog.open(AnnouncementsComponent);
    }
    var data = await lastValueFrom(
      this.http.post<boolean>(
        `/api/user/Eula/${id}/${contNum}/accepteulaagreements`,
        null
      )
    );
    if (data) {
      this.index++;
      if (this.index === this.eulaAgreements.length) {
        sessionStorage.setItem('eulaAccepted', 'true');
      }
    }
  }

  public licenseCancelled(input: any) {
    //this.router.navigate(['/unauthorized']);
    this.session.logoff();
  }

  public deleteMsg(id: any) {
    if (this.eulaAgreements.length - 1 == this.index) {
      this.eulaBinding = false;
      this.hasEulaAgreement = false;
      this.acceptedEulaAgreement.emit(this.hasEulaAgreement);
    }
  }
}
